<template>
  <BlankPage
      :setTitle="setTitle"
      :setBreadcrumbs="setBreadcrumbs"
  >
    <template
        v-slot:default="{
          title
        }"
    >
      <GridPart
          maxWidth="calc(100% - 40px)"
          :title="title"
          :hasSearch="true"
          :hasFilter="true"
          :hasExtra="false"
          :standardClass="() => {}"
          :extraClass="() => {}"
          :colspan="7"
          empty="Nenašli sa žiadne súbory."
          itemsKey="files"
          filterKey="File"
          :defaultFilters="{
            dir: null,
            type: null,
            status: null
          }"
          defaultOrder="fil.createdAt"
          defaultBy="DESC"
          :defaultLimit="25"
          :fetchData="fetchData"
      >
        <template
            v-slot:search="{
              params,
              errors,
              setSearch
            }"
        >
          <v-text-field
              v-model="params.query"
              :error-messages="errors.query"
              :outlined="true"
              :dense="true"
              hide-details="auto"
              label="Vyhľadávanie"
              :clearable="true"
              @change="setSearch"
          />
        </template>

        <template
            v-slot:filter="{
              params,
              errors,
              setFilter
            }"
        >
          <v-row>
            <v-col
                cols="12"
                lg="3"
            >
              <SuggestIndexesModule
                  v-model="params.Filters.dir"
                  :error-messages="errors.Filters?.dir"
                  :outlined="true"
                  :dense="true"
                  hide-details="auto"
                  label="Priečinok"
                  :clearable="true"
                  @change="setFilter"
                  module="file_dir"
              />
            </v-col>

            <v-col
                cols="12"
                lg="3"
            >
              <SuggestIndexesModule
                  v-model="params.Filters.type"
                  :error-messages="errors.Filters?.type"
                  :outlined="true"
                  :dense="true"
                  hide-details="auto"
                  label="Typ"
                  :clearable="true"
                  @change="setFilter"
                  module="file_type"
              />
            </v-col>

            <v-col
                cols="12"
                lg="3"
            >
              <v-select
                  v-model="params.Filters.status"
                  :error-messages="errors.Filters?.status"
                  :outlined="true"
                  :dense="true"
                  hide-details="auto"
                  label="Stav"
                  :items="statuses"
                  :clearable="true"
                  @change="setFilter"
              />
            </v-col>
          </v-row>
        </template>

        <template
            v-slot:list-head="{
              order,
              by,
              orderList,
              byList,
              setOrderBy
            }"
        >
          <th>
            Priečinok
          </th>

          <th>
            Názov
          </th>

          <th>
            Typ
          </th>

          <th>
            Stav
          </th>

          <th>
            <OrderList
                orderKey="fil.createdAt"
                :order="order"
                :by="by"
                :orderList="orderList"
                :byList="byList"
                @setOrderBy="setOrderBy"
            />
          </th>

          <th>
            <OrderList
                orderKey="fil.updatedAt"
                :order="order"
                :by="by"
                :orderList="orderList"
                :byList="byList"
                @setOrderBy="setOrderBy"
            />
          </th>

          <th
              class="text-right fixed"
          />
        </template>

        <template
            v-slot:list-body-standard="{
              Item
            }"
        >
          <td>
            {{ Item.dir }}
          </td>

          <td>
            <a
                :href="$global.axiosUrl() + 'files/' + Item.token + '/generate/original'"
                target="_blank"
            >
              <TruncateHelper
                  :title="Item.name"
                  maxWidth="300px"
              >
                {{ Item.name }}
              </TruncateHelper>
            </a>
          </td>

          <td>
            {{ Item.type }}
          </td>

          <td>
            {{ statusList[Item.status]?.text }}
          </td>

          <td>
            {{ Item.createdAt|moment('DD.MM.YYYY HH:mm') }}
          </td>

          <td>
            <IsEmptyHelper
                :value="Item.updatedAt"
                if-no="span"
                if-yes="span"
            >
              {{ Item.updatedAt|moment('DD.MM.YYYY HH:mm') }}
            </IsEmptyHelper>
          </td>

          <td
              class="text-right fixed"
          >
            <v-btn
                :icon="true"
                :outlined="true"
                color="primary"
                :to="'/file/' + Item.id"
            >
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </td>
        </template>
      </GridPart>
    </template>
  </BlankPage>
</template>

<script>
  import Files from '@/services/files'

  import BlankPage from '@/components/_Part/_Page/Blank'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  import SuggestIndexesModule from '@/components/Indexes/SuggestModule'

  export default {
    name: 'Files',
    components: {
      BlankPage,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper,
      SuggestIndexesModule
    },
    computed: {
      statusList: function () {
        return this.$store.state.core.Entity.File?.status
      },
      statuses: function () {
        return Object.values(this.statusList)
      }
    },
    methods: {
      fetchData(params) {
        return Files
          .index({
            params: params
          })
      },
      setTitle() {
        return 'Súbory'
      },
      setBreadcrumbs() {
        return []
      }
    }
  }
</script>
